// Import Firebase dependencies
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, OAuthProvider } from "firebase/auth";

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyCOkreZ3AFBrZyhbyshnsAWy2D61vYJsOw",
  authDomain: "td-jotform-login.firebaseapp.com",
  projectId: "td-jotform-login",
  storageBucket: "td-jotform-login.firebasestorage.app",
  messagingSenderId: "25737745285",
  appId: "1:25737745285:web:f40e11d4be0eac08d36aec",
  measurementId: "G-GZHHZ532WB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Microsoft Provider Configuration with Tenant ID (Single-Tenant)
const microsoftProvider = new OAuthProvider("microsoft.com");
microsoftProvider.setCustomParameters({
  tenant: "4ed7b887-e338-4680-b3ae-7ad2a8ec772a", // Your Azure Tenant ID
});

// Export authentication functions
export { auth, microsoftProvider, signInWithPopup };

